import type { QuestionnaireItem } from 'fhir/r4';

import { type FormDefinition, getTopLevelElements } from '@helsenorge/refero';

export const shouldFormBeDisplayedAsStepView = (formDefinition: FormDefinition): boolean => {
  let shouldDisplay = false;
  formDefinition.Content?.item?.find(qItem =>
    qItem.extension?.find(extension =>
      extension.valueCodeableConcept?.coding?.find(coding => {
        if (coding.code === 'step') {
          shouldDisplay = true;
        }
      })
    )
  );
  return shouldDisplay;
};

export const getTopLevelItems = (formDefinition: FormDefinition): QuestionnaireItem[] | undefined => {
  return getTopLevelElements(formDefinition);
};
